import { axios } from '@/utils/request'

const api = {
  getRobotUpdateLogList: '/5cb7df2baceab',
  sendGroupMessage: '/5cc2bd9f183e6',
  getQiniuToken: '/5cda9a63470bf',
  getSubscribeQrcode: '/5db14d6bae498',
  getSubscribeStatus: '/5db2c7fab79a2',
  deleteSubscribe: '/5db2c87d67d92',
  //   getSmsCaptcha: '/5dde4520c102d',
  getSmsCaptcha: '/68a80e4a624d5',
  getWxList: '/646f130ba7309', // 微信列表
  unbindWx: '/646f1dbcb5a76', // 解绑微信
  receiveMsg: '/64700913c306e', // 是否接受消息
}

export default {
  // 更新机器人更新日志列表
  getRobotUpdateLogList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
      type: 2,
      keyworks: 2,
    })
    return axios({
      url: api.getRobotUpdateLogList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },
  // 向子账户广播消息
  sendGroupMessage: ({ robotids, data }) => {
    const params = {
      sub_id_arr: robotids,
      message: JSON.stringify(data),
    }
    return axios({
      url: api.sendGroupMessage,
      method: 'post',
      data: params,
    })
  },
  // 获取七牛云上传凭证
  getQiniuToken() {
    const parameter = {}
    return axios({
      url: api.getQiniuToken,
      method: 'get',
      params: parameter,
    })
  },
  // 创建关注公众号二维码
  getSubscribeQrcode() {
    const parameter = {}
    return axios({
      url: api.getSubscribeQrcode,
      method: 'get',
      params: parameter,
    })
  },
  // 校验是否关注公众号
  getSubscribeStatus() {
    const parameter = {}
    return axios({
      url: api.getSubscribeStatus,
      method: 'get',
      params: parameter,
    })
  },
  // 解除绑定公众号
  deleteSubscribe() {
    const parameter = {}
    return axios({
      url: api.deleteSubscribe,
      method: 'get',
      params: parameter,
    })
  },
  // 获取短信验证码
  getSmsCaptcha(data) {
    return axios({
      url: api.getSmsCaptcha,
      method: 'post',
      data,
    })
  },

  // 获取微信列表
  getWxList: parameter => {
    return axios({
      url: api.getWxList,
      method: 'get',
      params: parameter,
    })
  },

  // 解绑微信
  unbindWx: parameter => {
    return axios({
      url: api.unbindWx,
      method: 'post',
      data: parameter,
    })
  },

  // 是否接收消息
  receiveMsg: parameter => {
    return axios({
      url: api.receiveMsg,
      method: 'get',
      params: parameter,
    })
  },
}
